import { changeControlEn } from './change-control-en';

export const changeControlEs = {
  ...changeControlEn,
  title: 'Gestión de cambios',
  subtitle: 'Evaluar impactos entre módulos, coordinar revisiones y crear revisiones controladas.',
  help: 'Abrir ayuda de gestión de cambios',
  tabs: { requests: 'Solicitudes de cambio', customerApprovals: 'Aprobaciones de clientes' },
  actions: {
    new: 'Nueva solicitud',
    analyze: 'Analizar impactos',
    submit: 'Enviar',
    reviewed: 'Completar revisión',
    'changes-requested': 'Solicitar correcciones',
    approve: 'Aprobar',
    reject: 'Rechazar',
    'start-implementation': 'Iniciar implementación',
    complete: 'Completar implementación',
    cancel: 'Cancelar solicitud',
    archive: 'Archivar',
  },
  filters: {
    search: 'Buscar número, título, origen o artículo',
    allStatuses: 'Todos los estados',
    allRisks: 'Todos los riesgos',
    allSources: 'Todos los tipos de origen',
  },
  columns: {
    number: 'Número',
    title: 'Título',
    source: 'Origen',
    status: 'Estado',
    risk: 'Riesgo',
    responsible: 'Responsable',
    impact: 'Objetos afectados',
    updated: 'Actualizado',
    actions: 'Acciones',
  },
  statuses: {
    DRAFT: 'Borrador',
    IN_REVIEW: 'En revisión',
    CHANGES_REQUESTED: 'Correcciones requeridas',
    REVIEWED: 'Revisado',
    APPROVED: 'Aprobado',
    IMPLEMENTING: 'En implementación',
    IMPLEMENTED: 'Implementado',
    REJECTED: 'Rechazado',
    CANCELLED: 'Cancelado',
    ARCHIVED: 'Archivado',
  },
  risks: { LOW: 'Bajo', MEDIUM: 'Medio', HIGH: 'Alto', CRITICAL: 'Crítico' },
  sourceTypes: {
    PRODUCT: 'Artículo / materia',
    MATERIAL_PROFILE: 'Perfil de material',
    SUPPLIER_SPECIFICATION: 'Especificación de proveedor',
    RECIPE: 'Receta / BOM',
    DECLARATION: 'Declaración',
    ANALYSIS_PROFILE: 'Análisis / nutrición',
    PROCESS_ROUTING: 'Ruta de proceso',
    PACKAGING: 'Embalaje',
  },
  assigneeRoles: {
    RESPONSIBLE: 'Responsable',
    REVIEWER: 'Revisor',
    APPROVER: 'Aprobador',
    OBSERVER: 'Observador',
  },
  taskStatuses: {
    OPEN: 'Abierta',
    IN_PROGRESS: 'En curso',
    COMPLETED: 'Completada',
    CANCELLED: 'Cancelada',
  },
  decisions: {
    SUBMITTED: 'Enviada',
    REVIEWED: 'Revisada',
    CHANGES_REQUESTED: 'Correcciones solicitadas',
    APPROVED: 'Aprobada',
    REJECTED: 'Rechazada',
    IMPLEMENTING: 'Implementación iniciada',
    IMPLEMENTED: 'Implementada',
    CANCELLED: 'Cancelada',
    ARCHIVED: 'Archivada',
  },
  nodeTypes: {
    SOURCE: 'Origen del cambio',
    RECIPE: 'Recetas / BOM',
    PRODUCT: 'Productos',
    PRODUCTION_ORDER: 'Órdenes de producción',
    PRODUCTION_PLAN: 'Planificación de producción',
    DECLARATION: 'Declaraciones',
    SPECIFICATION: 'Especificaciones de producto',
    LABEL_TEMPLATE: 'Plantillas de etiqueta',
    CUSTOMER_APPROVAL: 'Aprobaciones de clientes',
    SALES_ORDER: 'Pedidos de venta abiertos',
    PROCESS_ROUTING: 'Rutas de proceso',
    ANALYSIS_PROFILE: 'Perfiles de análisis',
    PACKAGING: 'Embalajes',
  },
  draftTargetTypes: {
    RECIPE: 'Receta / BOM',
    PROCESS_ROUTING: 'Ruta de proceso',
    DECLARATION: 'Declaración',
    ANALYSIS_PROFILE: 'Perfil de análisis',
    SPECIFICATION: 'Especificación de producto',
    LABEL_TEMPLATE: 'Plantilla de etiqueta',
  },
  draftStatuses: { PROCESSING: 'Creando', CREATED: 'Revisión creada', FAILED: 'Error al crear' },
  form: {
    newTitle: 'Crear solicitud de cambio',
    newDescription: 'Registrar origen, estado objetivo, riesgo y responsabilidades independientes.',
    editTitle: 'Editar solicitud',
    editDescription: 'Solo se pueden editar borradores y solicitudes devueltas.',
    title: 'Título',
    reason: 'Motivo',
    sourceType: 'Tipo de origen',
    source: 'Objeto de origen',
    sourceVersion: 'Versión de origen',
    sourceSearch: 'Buscar origen',
    sourceSearchPlaceholder: 'Número, nombre, proveedor o dominio',
    selectSource: 'Seleccionar un origen controlado',
    noSources: 'No hay un origen coincidente.',
    noVersion: 'Datos maestros sin versión separada',
    sourceIdPlaceholder: 'ID del objeto de origen',
    optionalId: 'ID de versión opcional',
    selectProduct: 'Seleccionar artículo',
    risk: 'Nivel de riesgo',
    riskAssessment: 'Evaluación de riesgos',
    before: 'Antes',
    after: 'Después',
    requestedEffectiveDate: 'Fecha de vigencia solicitada',
    effectiveDate: 'Fecha de vigencia',
    dueDate: 'Fecha límite',
    responsibleId: 'Responsable',
    reviewerId: 'Revisor',
    approverId: 'Aprobador',
    selectUser: 'Seleccionar usuario',
    note: 'Nota justificada',
  },
  messages: {
    invalidJson: 'Los valores anterior y posterior deben ser objetos JSON válidos.',
    invalidForm: 'Complete todos los campos obligatorios con valores válidos.',
    noteRequired: 'Introduzca una nota justificada de al menos tres caracteres.',
    created: 'Se creó la solicitud {{number}}.',
    saved: 'Cambios guardados.',
    analyzed: 'Análisis de impacto guardado.',
    notFound: 'No se encontró la solicitud.',
    workflow: {
      submit: 'Enviada a revisión.',
      reviewed: 'Revisión completada.',
      'changes-requested': 'Correcciones solicitadas.',
      approve: 'Solicitud aprobada.',
      reject: 'Solicitud rechazada.',
      'start-implementation': 'Implementación iniciada.',
      complete: 'Implementación completada.',
      cancel: 'Solicitud cancelada.',
      archive: 'Solicitud archivada.',
    },
  },
  sections: {
    overview: 'Resumen',
    request: 'Solicitud y riesgo',
    assignees: 'Responsabilidades',
    diff: 'Antes / después',
    impact: 'Grafo de impacto',
    tasks: 'Tareas',
    drafts: 'Revisiones controladas',
    documents: 'Documentos',
    audit: 'Historial de revisión y auditoría',
  },
  diff: {
    beforeDescription: 'Estado inicial inmutable registrado con la solicitud.',
    afterDescription: 'Estado objetivo que debe revisarse y aprobarse.',
  },
  impact: {
    warnings: 'Advertencias del análisis de impacto',
    relations: 'Relaciones',
    noRelations: 'No se identificaron relaciones.',
    openNode: 'Abrir {{label}}',
    requiredTitle: 'Se requiere un análisis de impacto actual',
    requiredDescription: 'Analice y guarde todos los objetos afectados antes de enviar.',
    notAnalyzed: 'No hay un análisis de impacto actual.',
    version: 'Instantánea de impacto v{{version}}, creada el {{date}}',
  },
  impactWarnings: {
    SUPPLIER_SOURCE_NOT_VERSIONED:
      'La información del proveedor no tiene versión separada; el expediente congela los valores antes/después.',
    PACKAGING_SOURCE_NOT_VERSIONED:
      'Los datos maestros de embalaje no tienen versión separada; el expediente congela los valores antes/después.',
    BOM_TRAVERSAL_DEPTH_REACHED: 'El recorrido de BOM alcanzó la profundidad máxima de 50.',
    NO_DEPENDENCIES: 'No se encontraron objetos dependientes para este origen.',
  },
  tasks: {
    new: 'Añadir tarea',
    description: 'Asignar una actividad concreta, un responsable y una fecha límite.',
    created: 'Tarea creada.',
    completedInUi: 'Completada en el flujo de cambios.',
    complete: 'Completar',
    reopen: 'Reabrir',
    columns: { status: 'Estado', task: 'Tarea', assignee: 'Asignado a', due: 'Fecha límite' },
    form: { description: 'Descripción' },
  },
  drafts: {
    title: 'Las versiones publicadas no cambian',
    description:
      'Cree un nuevo borrador o revisión controlada para cada versión aprobada afectada. Nunca se sobrescriben documentos publicados.',
    pending: 'Aún no se creó una revisión',
    create: 'Crear revisión',
    created: 'Se creó un borrador o revisión controlada.',
  },
  workflow: {
    submit: {
      title: 'Enviar solicitud',
      description: 'La instantánea de impacto se congela para la revisión independiente.',
    },
    reviewed: {
      title: 'Completar revisión',
      description: 'Confirme que se comprobaron impactos, riesgo y estado objetivo.',
    },
    'changes-requested': {
      title: 'Solicitar correcciones',
      description: 'Describa con precisión qué debe corregirse.',
    },
    approve: {
      title: 'Aprobar solicitud',
      description: 'Defina la fecha de vigencia y aporte una nota de aprobación independiente.',
    },
    reject: { title: 'Rechazar solicitud', description: 'Registre por qué no debe implementarse.' },
    'start-implementation': {
      title: 'Iniciar implementación',
      description: 'Ya se pueden completar tareas y revisiones controladas.',
    },
    complete: {
      title: 'Completar implementación',
      description: 'Todas las tareas y revisiones requeridas deben estar completas.',
    },
    cancel: {
      title: 'Cancelar solicitud',
      description: 'La cancelación se audita y no modifica documentos publicados.',
    },
    archive: {
      title: 'Archivar solicitud',
      description: 'El expediente y sus pruebas permanecen inmutables.',
    },
  },
  empty: {
    requests: 'Ninguna solicitud coincide con los filtros.',
    approvals: 'No hay aprobaciones de clientes.',
    tasks: 'No se añadieron tareas.',
    drafts: 'No hay una versión aprobada que requiera una revisión sucesora.',
    audit: 'No se registraron decisiones de flujo.',
  },
  taskCount: '{{count}} tarea(s) abierta(s)',
  pagination: 'Página {{page}} de {{pages}} · {{total}} solicitudes',
  customer: {
    actions: { new: 'Nueva aprobación de cliente', approve: 'Aprobar', revoke: 'Revocar' },
    columns: {
      reference: 'Referencia',
      customer: 'Cliente',
      product: 'Artículo',
      scope: 'Alcance',
      validity: 'Vigencia',
    },
    statuses: { DRAFT: 'Borrador', APPROVED: 'Aprobada', EXPIRED: 'Caducada', REVOKED: 'Revocada' },
    form: {
      title: 'Registrar aprobación de cliente',
      description:
        'Los datos aprobados se guardan como instantánea protegida por hash y requieren aprobación independiente.',
      selectCustomer: 'Seleccionar cliente',
      snapshot: 'Instantánea de datos aprobados (JSON)',
      validFrom: 'Válida desde',
      validTo: 'Válida hasta',
    },
    dialog: {
      approve: 'Aprobar aprobación de cliente',
      revoke: 'Revocar aprobación de cliente',
      description: 'La decisión y el motivo se escriben en la pista de auditoría.',
    },
    messages: {
      created: 'Aprobación de cliente creada.',
      approved: 'Aprobación de cliente aprobada.',
      revoked: 'Aprobación de cliente revocada.',
    },
  },
} as const;
